import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "../dynamic_applet.module.scss"

export default class TransactionLogRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      detailsOpen: false,
    }
  }

  toggleDetails = () => {
    this.setState({ detailsOpen: !this.state.detailsOpen })
  }

  requestPath = () => {
    if (this.props.transaction.request_url) {
      let url = this.props.transaction.request_url
      // remove hostname part
      return url.substring(url.indexOf("/", 8))
    } else {
      return ""
    }
  }

  renderRequestSummary = () => {
    return (
      <>
        {this.props.transaction.request_method}&nbsp;{this.requestPath()}
      </>
    )
  }

  renderHeaders = headers => {
    return Object.entries(headers).map(([k, v], i) => {
      return (
        <>
          <code>
            {k}: {v}
          </code>
          <br />
        </>
      )
    })
  }

  render() {
    const transaction = this.props.transaction

    return (
      <section>
        <div
          className={classnames("entry", {
            open: this.state.detailsOpen,
            closed: !this.state.detailsOpen,
          })}
        >
          <div className="entry-summary" onClick={this.toggleDetails}>
            <div className={styles["logs-column"]}>
              {new Intl.DateTimeFormat("en-US", {
                month: "long",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              }).format(transaction.ts)}
            </div>
            <div className={styles["logs-column"]}>{this.renderRequestSummary()}</div>
            <div className={styles["logs-column"]}>{transaction.type_ui_label}</div>
            <div className={styles["logs-column"]}>{transaction.response_status}</div>
          </div>
          <div className="entry-details">
            <h5>Transaction</h5>
            <section>
              <p>
                <strong>Request ID</strong>
                <br />
                {transaction.id}
              </p>
              <p>
                <strong>User</strong>
                <br />
                {transaction.remote_user_id}
              </p>
              <p>
                <strong>Execution Time</strong>
                <br />
                {transaction.time}
              </p>
            </section>

            <>
              <h5>Request</h5>
              <section>
                <p>
                  <strong>Method</strong>
                  <br />
                  {transaction.request_method}
                </p>
                <p>
                  <strong>URL</strong>
                  <br />
                  {transaction.request_url}
                </p>
                <p>
                  <strong>Headers</strong>
                  <br />
                  {transaction.request_headers && this.renderHeaders(transaction.request_headers)}
                </p>
                <p>
                  <strong>Body</strong>
                  <br />
                  <code>{transaction.request_body}</code>
                </p>
              </section>
            </>

            <>
              <h5>Response</h5>
              <section>
                <p>
                  <strong>Status</strong>
                  <br />
                  {transaction.response_status}
                </p>
                <p>
                  <strong>Headers</strong>
                  <br />
                  {transaction.response_headers && this.renderHeaders(transaction.response_headers)}
                </p>
                <p>
                  <strong>Body</strong>
                  <br />
                  <code>{transaction.response_body}</code>
                </p>
              </section>
            </>
          </div>
        </div>
      </section>
    )
  }
}

// We don't normally expect missing fields but we should be able to handle any missing field,
// so declaring them all as optional here.
TransactionLogRow.propTypes = {
  transaction: PropTypes.shape({
    id: PropTypes.string,
    type_ui_label: PropTypes.string,
    ts: PropTypes.string,
    remote_user_id: PropTypes.string,
    time: PropTypes.string,
    request_method: PropTypes.string,
    request_url: PropTypes.string,
    request_headers: PropTypes.objectOf(PropTypes.string),
    request_body: PropTypes.string,
    response_status: PropTypes.string,
    response_headers: PropTypes.objectOf(PropTypes.string),
    response_body: PropTypes.string,
  }).isRequired,
}
